export enum WindowSize {
  MobileSmall = 1,
  Mobile = 2,
  DesktopSmall = 3,
  DesktopMedium = 4,
  DesktopLarge = 5,
  DesktopFull = 6,
}
